import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
function Privacy(props) {
  return (
    <div>
      <div className="wrapper banner3 position-relative mh-new">
        <div className="overlay">
          <CustomHelmet page="Our Privacy" />
          <Navbar search={true} props={props} user={props.user} />
          <div className="banner">
            <div className="content text-left mt-6 container">
              <h2>PRIVACY POLICY OF HUBSQUARES</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div>
          <div>
            <div>
              <div>
                <h1 className="text-red">
                  Privacy Policy of <strong>Hubsquares</strong>
                </h1>

                <p>Hubsquares collects some Personal Data from its Users.</p>
                <br />
                <p>
                  This document has{" "}
                  <HashLink
                    className="text-dark font-italic"
                    smooth
                    to="#california_info"
                  >
                    a section dedicated to Californian consumers and their
                    privacy rights
                  </HashLink>
                  .
                </p>
                <p>
                  This document can be printed for reference by using the print
                  command in the settings of any browser.
                </p>
              </div>

              <div>
                <h2>Owner and Data Controller</h2>
                <p>Hubsquares</p>
                <p>
                  <b>Owner contact email:</b> hsqsupport@hubsquares.com
                </p>
              </div>

              <div>
                <h2>Types of Data collected</h2>

                <p>
                  Among the types of Personal Data that Hubsquares collects, by
                  itself or through third parties, there are: first name; last
                  name; phone number; company name; address; country; state;
                  county; email address; city; website; date of birth;
                  Approximate location permission (continuous); Biometric Data
                  access permission; geographic position; Cookies; Usage Data;
                  username; various types of Data; gender; password; ZIP/Postal
                  code; picture; billing address; field of activity; house
                  number; profession.
                </p>

                <p>
                  Complete details on each type of Personal Data collected are
                  provided in the dedicated sections of this privacy policy or
                  by specific explanation texts displayed prior to the Data
                  collection.
                  <br />
                  Personal Data may be freely provided by the User, or, in case
                  of Usage Data, collected automatically when using Hubsquares.
                  <br />
                  Unless specified otherwise, all Data requested by Hubsquares
                  is mandatory and failure to provide this Data may make it
                  impossible for Hubsquares to provide its services. In cases
                  where Hubsquares specifically states that some Data is not
                  mandatory, Users are free not to communicate this Data without
                  consequences to the availability or the functioning of the
                  Service.
                  <br />
                  Users who are uncertain about which Personal Data is mandatory
                  are welcome to contact the Owner.
                  <br />
                  Any use of Cookies – or of other tracking tools – by
                  Hubsquares or by the owners of third-party services used by
                  Hubsquares serves the purpose of providing the Service
                  required by the User, in addition to any other purposes
                  described in the present document and in the Cookie Policy, if
                  available.
                </p>
                <p>
                  Users are responsible for any third-party Personal Data
                  obtained, published or shared through Hubsquares and confirm
                  that they have the third party's consent to provide the Data
                  to the Owner.
                </p>
              </div>

              <div>
                <h2>Mode and place of processing the Data</h2>
                <h3>Methods of processing</h3>
                <p>
                  The Owner takes appropriate security measures to prevent
                  unauthorized access, disclosure, modification, or unauthorized
                  destruction of the Data.
                  <br />
                  The Data processing is carried out using computers and/or IT
                  enabled tools, following organizational procedures and modes
                  strictly related to the purposes indicated. In addition to the
                  Owner, in some cases, the Data may be accessible to certain
                  types of persons in charge, involved with the operation of
                  Hubsquares (administration, sales, marketing, legal, system
                  administration) or external parties (such as third-party
                  technical service providers, mail carriers, hosting providers,
                  IT companies, communications agencies) appointed, if
                  necessary, as Data Processors by the Owner. The updated list
                  of these parties may be requested from the Owner at any time.
                </p>
                <h3>Legal basis of processing</h3>
                <p>
                  The Owner may process Personal Data relating to Users if one
                  of the following applies:
                </p>
                <ul>
                  <li>
                    Users have given their consent for one or more specific
                    purposes. Note: Under some legislations the Owner may be
                    allowed to process Personal Data until the User objects to
                    such processing (“opt-out”), without having to rely on
                    consent or any other of the following legal bases. This,
                    however, does not apply, whenever the processing of Personal
                    Data is subject to European data protection law;
                  </li>
                  <li>
                    provision of Data is necessary for the performance of an
                    agreement with the User and/or for any pre-contractual
                    obligations thereof;
                  </li>
                  <li>
                    processing is necessary for compliance with a legal
                    obligation to which the Owner is subject;
                  </li>
                  <li>
                    processing is related to a task that is carried out in the
                    public interest or in the exercise of official authority
                    vested in the Owner;
                  </li>
                  <li>
                    processing is necessary for the purposes of the legitimate
                    interests pursued by the Owner or by a third party.
                  </li>
                </ul>
                <p>
                  In any case, the Owner will gladly help to clarify the
                  specific legal basis that applies to the processing, and in
                  particular whether the provision of Personal Data is a
                  statutory or contractual requirement, or a requirement
                  necessary to enter into a contract.{" "}
                </p>
                <h3>Place</h3>
                <p>
                  The Data is processed at the Owner's operating offices and in
                  any other places where the parties involved in the processing
                  are located.
                  <br />
                  <br />
                  Depending on the User's location, data transfers may involve
                  transferring the User's Data to a country other than their
                  own. To find out more about the place of processing of such
                  transferred Data, Users can check the section containing
                  details about the processing of Personal Data.
                </p>
                <p>
                  Users are also entitled to learn about the legal basis of Data
                  transfers to a country outside the European Union or to any
                  international organization governed by public international
                  law or set up by two or more countries, such as the UN, and
                  about the security measures taken by the Owner to safeguard
                  their Data.
                  <br />
                  <br />
                  If any such transfer takes place, Users can find out more by
                  checking the relevant sections of this document or inquire
                  with the Owner using the information provided in the contact
                  section.
                </p>
                <h3>Retention time</h3>
                <p>
                  Personal Data shall be processed and stored for as long as
                  required by the purpose they have been collected for.
                </p>
                <p>Therefore:</p>
                <ul>
                  <li>
                    Personal Data collected for purposes related to the
                    performance of a contract between the Owner and the User
                    shall be retained until such contract has been fully
                    performed.
                  </li>
                  <li>
                    Personal Data collected for the purposes of the Owner’s
                    legitimate interests shall be retained as long as needed to
                    fulfill such purposes. Users may find specific information
                    regarding the legitimate interests pursued by the Owner
                    within the relevant sections of this document or by
                    contacting the Owner.
                  </li>
                </ul>
                <p>
                  The Owner may be allowed to retain Personal Data for a longer
                  period whenever the User has given consent to such processing,
                  as long as such consent is not withdrawn. Furthermore, the
                  Owner may be obliged to retain Personal Data for a longer
                  period whenever required to do so for the performance of a
                  legal obligation or upon order of an authority.
                  <br />
                  <br />
                  Once the retention period expires, Personal Data shall be
                  deleted. Therefore, the right to access, the right to erasure,
                  the right to rectification and the right to data portability
                  cannot be enforced after expiration of the retention period.
                </p>
              </div>

              <div>
                <h2>The purposes of processing</h2>
                <p>
                  The Data concerning the User is collected to allow the Owner
                  to provide its Service, comply with its legal obligations,
                  respond to enforcement requests, protect its rights and
                  interests (or those of its Users or third parties), detect any
                  malicious or fraudulent activity, as well as the following:
                  Contacting the User, Device permissions for Personal Data
                  access, Location-based interactions, Displaying content from
                  external platforms, Content commenting, Data transfer outside
                  the EU, Handling payments, Analytics, Interaction with data
                  collection platforms and other third parties, Interaction with
                  external social networks and platforms, Managing contacts and
                  sending messages, Registration and authentication provided
                  directly by Hubsquares and Social features.
                </p>

                <p>
                  For specific information about the Personal Data used for each
                  purpose, the User may refer to the section “Detailed
                  information on the processing of Personal Data”.
                </p>
              </div>

              <div>
                <h2>Device permissions for Personal Data access</h2>
                <p>
                  Depending on the User's specific device, Hubsquares may
                  request certain permissions that allow it to access the User's
                  device Data as described below.
                </p>
                <p>
                  By default, these permissions must be granted by the User
                  before the respective information can be accessed. Once the
                  permission has been given, it can be revoked by the User at
                  any time. In order to revoke these permissions, Users may
                  refer to the device settings or contact the Owner for support
                  at the contact details provided in the present document.
                  <br />
                  The exact procedure for controlling app permissions may be
                  dependent on the User's device and software.
                </p>
                <p>
                  Please note that the revoking of such permissions might impact
                  the proper functioning of Hubsquares.
                </p>
                <p>
                  If User grants any of the permissions listed below, the
                  respective Personal Data may be processed (i.e accessed to,
                  modified or removed) by Hubsquares.
                </p>
                <h3>Approximate location permission (continuous)</h3>
                <p>
                  Used for accessing the User's approximate device location.
                  Hubsquares may collect, use, and share User location Data in
                  order to provide location-based services.
                </p>

                <h3>Biometric Data access permission</h3>
                <p>
                  Used for accessing the User's biometrical Data and/or
                  authentication systems, such as for instance, FaceID.
                </p>
              </div>

              <div>
                <h2 id="data_processing_detailed_info">
                  Detailed information on the processing of Personal Data
                </h2>
                <p>
                  Personal Data is collected for the following purposes and
                  using the following services:
                </p>
                <ul>
                  <li>
                    <div>
                      <h3>Analytics</h3>
                      <div>
                        <p>
                          The services contained in this section enable the
                          Owner to monitor and analyze web traffic and can be
                          used to keep track of User behavior.
                        </p>

                        <h4>Google Analytics (Google LLC)</h4>
                        <div>
                          <p>
                            Google Analytics is a web analysis service provided
                            by Google LLC (“Google”). Google utilizes the Data
                            collected to track and examine the use of
                            Hubsquares, to prepare reports on its activities and
                            share them with other Google services.
                            <br />
                            Google may use the Data collected to contextualize
                            and personalize the ads of its own advertising
                            network.
                          </p>
                        </div>

                        <p>Personal Data processed: Cookies; Usage Data.</p>

                        <p>
                          Place of processing: United States &ndash;
                          <a
                            href="https://policies.google.com/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>{" "}
                          &ndash;{" "}
                          <a
                            href="https://tools.google.com/dlpage/gaoptout?hl=en"
                            rel="noopener noreferrer"
                            target="_blank"
                            className="text-dark font-italic"
                          >
                            Opt Out
                          </a>
                          . Privacy Shield participant.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Contacting the User</h3>
                      <div>
                        <h4>Contact form (Hubsquares)</h4>
                        <div>
                          <p>
                            By filling in the contact form with their Data, the
                            User authorizes Hubsquares to use these details to
                            reply to requests for information, quotes or any
                            other kind of request as indicated by the form’s
                            header.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: address; city; company name;
                          country; county; date of birth; email address; first
                          name; last name; phone number; state; website.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; commercial information; internet
                          information.
                        </p>

                        <h4>Phone contact (Hubsquares)</h4>
                        <div>
                          <p>
                            Users that provided their phone number might be
                            contacted for commercial or promotional purposes
                            related to Hubsquares, as well as for fulfilling
                            support requests.
                          </p>
                        </div>

                        <p>Personal Data processed: phone number.</p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Content commenting</h3>
                      <div>
                        <p>
                          Content commenting services allow Users to make and
                          publish their comments on the contents of Hubsquares.
                          <br />
                          Depending on the settings chosen by the Owner, Users
                          may also leave anonymous comments. If there is an
                          email address among the Personal Data provided by the
                          User, it may be used to send notifications of comments
                          on the same content. Users are responsible for the
                          content of their own comments.
                          <br />
                          If a content commenting service provided by third
                          parties is installed, it may still collect web traffic
                          data for the pages where the comment service is
                          installed, even when Users do not use the content
                          commenting service.
                        </p>

                        <h4>Comment system managed directly (Hubsquares)</h4>
                        <div>
                          <p>
                            Hubsquares has its own internal content comment
                            system.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: Cookies; email address; first
                          name; last name; phone number; username; website.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; internet information.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Data transfer outside the EU</h3>
                      <div>
                        <p>
                          The Owner is allowed to transfer Personal Data
                          collected within the EU to third countries (i.e. any
                          country not part of the EU) only pursuant to a
                          specific legal basis. Any such Data transfer is based
                          on one of the legal bases described below.
                          <br />
                          Users can inquire with the Owner to learn which legal
                          basis applies to which specific service.
                        </p>

                        <h4>
                          Other legal basis for Data transfer abroad
                          (Hubsquares)
                        </h4>
                        <div>
                          <p>
                            If no other legal basis applies, Personal Data shall
                            be transferred from the EU to third countries only
                            if at least one of the following conditions is met:
                          </p>

                          <ul>
                            <li>
                              the transfer is necessary for the performance of a
                              contract between the User and the Owner or of
                              pre-contractual measures taken at the User’s
                              request;
                            </li>
                            <li>
                              the transfer is necessary for the conclusion or
                              performance of a contract concluded in the
                              interest of the User between the Owner and another
                              natural or legal person;
                            </li>
                            <li>
                              the transfer is necessary for important reasons of
                              public interest;
                            </li>
                            <li>
                              the transfer is necessary for establishment,
                              exercise or defence of legal claims;
                            </li>
                            <li>
                              the transfer is necessary in order to protect the
                              vital interests of the data subject or of other
                              persons, where the data subject is physically or
                              legally incapable of giving consent. In such
                              cases, the Owner shall inform the User about the
                              legal bases the transfer is based on via
                              Hubsquares.
                            </li>
                          </ul>
                        </div>

                        <p>Personal Data processed: various types of Data.</p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Device permissions for Personal Data access</h3>
                      <div>
                        <p>
                          Hubsquares requests certain permissions from Users
                          that allow it to access the User's device Data as
                          described below.
                        </p>

                        <h4>
                          Device permissions for Personal Data access
                          (Hubsquares)
                        </h4>
                        <div>
                          <p>
                            Hubsquares requests certain permissions from Users
                            that allow it to access the User's device Data as
                            summarized here and described within this document.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: Approximate location
                          permission (continuous); Biometric Data access
                          permission.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          biometric information; geolocation data.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Displaying content from external platforms</h3>
                      <div>
                        <p>
                          This type of service allows you to view content hosted
                          on external platforms directly from the pages of
                          Hubsquares and interact with them.
                          <br />
                          This type of service might still collect web traffic
                          data for the pages where the service is installed,
                          even when Users do not use it.
                        </p>

                        <h4>Google Maps widget (Google LLC)</h4>
                        <div>
                          <p>
                            Google Maps is a maps visualization service provided
                            by Google LLC that allows Hubsquares to incorporate
                            content of this kind on its pages.
                          </p>
                        </div>

                        <p>Personal Data processed: Cookies; Usage Data.</p>

                        <p>
                          Place of processing: United States &ndash;
                          <a
                            href="https://policies.google.com/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>
                          . Privacy Shield participant.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Handling payments</h3>
                      <div>
                        <p>
                          Unless otherwise specified, Hubsquares processes any
                          payments by credit card, bank transfer or other means
                          via external payment service providers. In general and
                          unless where otherwise stated, Users are requested to
                          provide their payment details and personal information
                          directly to such payment service providers. Hubsquares
                          isn't involved in the collection and processing of
                          such information: instead, it will only receive a
                          notification by the relevant payment service provider
                          as to whether payment has been successfully completed.
                        </p>

                        <h4>PayPal (PayPal Inc.)</h4>
                        <div>
                          <p>
                            PayPal is a payment service provided by PayPal Inc.,
                            which allows Users to make online payments.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: various types of Data as
                          specified in the privacy policy of the service.
                        </p>

                        <p>
                          Place of processing: See the PayPal privacy policy
                          &ndash;
                          <a
                            href="https://www.paypal.com/webapps/mpp/ua/privacy-full "
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>
                          .
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>

                        <h4>PayPal Payments Hub (PayPal Inc.)</h4>
                        <div>
                          <p>
                            PayPal Payments Hub is a payment service provided by
                            PayPal Inc.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: various types of Data as
                          specified in the privacy policy of the service.
                        </p>

                        <p>
                          Place of processing: See the PayPal privacy policy
                          &ndash;
                          <a
                            href="https://www.paypal.com/webapps/mpp/ua/privacy-full"
                            target="_blank"
                            className="text-dark font-italic"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </a>
                          .
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>
                        Interaction with data collection platforms and other
                        third parties
                      </h3>
                      <div>
                        <p>
                          This type of service allows Users to interact with
                          data collection platforms or other services directly
                          from the pages of Hubsquares for the purpose of saving
                          and reusing data.
                          <br />
                          If one of these services is installed, it may collect
                          browsing and Usage Data in the pages where it is
                          installed, even if the Users do not actively use the
                          service.
                        </p>

                        <h4>Mailchimp widget (The Rocket Science Group LLC)</h4>
                        <div>
                          <p>
                            The Mailchimp widget is a service for interacting
                            with the Mailchimp email address management and
                            message sending service provided by The Rocket
                            Science Group LLC.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: email address; first name;
                          last name.
                        </p>

                        <p>
                          Place of processing: United States &ndash;
                          <a
                            href="https://mailchimp.com/legal/privacy/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>
                          . Privacy Shield participant.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>
                        Interaction with external social networks and platforms
                      </h3>
                      <div>
                        <p>
                          This type of service allows interaction with social
                          networks or other external platforms directly from the
                          pages of Hubsquares.
                          <br />
                          The interaction and information obtained through
                          Hubsquares are always subject to the User’s privacy
                          settings for each social network.
                          <br />
                          This type of service might still collect traffic data
                          for the pages where the service is installed, even
                          when Users do not use it.
                          <br />
                          It is recommended to log out from the respective
                          services in order to make sure that the processed data
                          on Hubsquares isn’t being connected back to the User’s
                          profile.
                        </p>

                        <h4>PayPal button and widgets (PayPal Inc.)</h4>
                        <div>
                          <p>
                            The PayPal button and widgets are services allowing
                            interaction with the PayPal platform provided by
                            PayPal Inc.
                          </p>
                        </div>

                        <p>Personal Data processed: Cookies; Usage Data.</p>

                        <p>
                          Place of processing: See the PayPal privacy policy
                          &ndash;
                          <a
                            href="https://www.paypal.com/webapps/mpp/ua/privacy-full"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>
                          .
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          internet information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Location-based interactions</h3>
                      <div>
                        <h4>Geolocation (Hubsquares)</h4>
                        <div>
                          <p>
                            Hubsquares may collect, use, and share User location
                            Data in order to provide location-based services.
                            <br />
                            Most browsers and devices provide tools to opt out
                            from this feature by default. If explicit
                            authorization has been provided, the User’s location
                            data may be tracked by Hubsquares.
                          </p>
                        </div>

                        <p>Personal Data processed: geographic position.</p>

                        <p>
                          Category of personal data collected according to CCPA:
                          geolocation data.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Managing contacts and sending messages</h3>
                      <div>
                        <p>
                          This type of service makes it possible to manage a
                          database of email contacts, phone contacts or any
                          other contact information to communicate with the
                          User.
                          <br />
                          These services may also collect data concerning the
                          date and time when the message was viewed by the User,
                          as well as when the User interacted with it, such as
                          by clicking on links included in the message.
                        </p>

                        <h4>
                          ActiveCampaign Text Message and SMS Marketing
                          (ActiveCampaign, Inc.)
                        </h4>
                        <div>
                          <p>
                            ActiveCampaign Text Message and SMS Marketing is an
                            email address management and message sending service
                            provided by ActiveCampaign, Inc.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: company name; email address;
                          first name; username.
                        </p>

                        <p>
                          Place of processing: United States &ndash;
                          <a
                            href="https://www.activecampaign.com/legal/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark font-italic"
                          >
                            Privacy Policy
                          </a>
                          . Privacy Shield participant.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; commercial information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>

                        <h4>Mailchimp (The Rocket Science Group LLC)</h4>
                        <div>
                          <p>
                            Mailchimp is an email address management and message
                            sending service provided by The Rocket Science Group
                            LLC.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: address; company name;
                          Cookies; country; email address; first name; last
                          name; username.
                        </p>

                        <p>
                          Place of processing: United States &ndash;
                          <a
                            href="https://mailchimp.com/legal/privacy/"
                            target="_blank"
                            className="text-dark font-italic"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                          </a>
                          . Privacy Shield participant.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; commercial information; internet
                          information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>
                        Registration and authentication provided directly by
                        Hubsquares
                      </h3>
                      <div>
                        <p>
                          By registering or authenticating, Users allow
                          Hubsquares to identify them and give them access to
                          dedicated services. The Personal Data is collected and
                          stored for registration or identification purposes
                          only. The Data collected are only those necessary for
                          the provision of the service requested by the Users.
                        </p>

                        <h4>Direct registration (Hubsquares)</h4>
                        <div>
                          <p>
                            The User registers by filling out the registration
                            form and providing the Personal Data directly to
                            Hubsquares.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: address; billing address;
                          city; company name; Cookies; country; county; date of
                          birth; email address; field of activity; first name;
                          gender; house number; last name; password; phone
                          number; picture; state; Usage Data; website;
                          ZIP/Postal code.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; commercial information; biometric
                          information; internet information; sensorial
                          information.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h3>Social features</h3>
                      <div>
                        <h4>Public profile (Hubsquares)</h4>
                        <div>
                          <p>
                            Users may have public profiles that other Users can
                            display. In addition to the Personal Data provided,
                            this profile may contain Users' interactions with
                            Hubsquares.
                          </p>
                        </div>

                        <p>
                          Personal Data processed: address; city; company name;
                          country; county; email address; first name; gender;
                          geographic position; last name; phone number; picture;
                          profession; state; username.
                        </p>

                        <p>
                          Category of personal data collected according to CCPA:
                          identifiers; commercial information; biometric
                          information; geolocation data; sensorial information;
                          employment related information.
                        </p>

                        <p>
                          This processing constitutes a sale based on the
                          definition under the CCPA. In addition to the
                          information in this clause, the User can find
                          information regarding how to opt out of the sale in
                          the section detailing the rights of Californian
                          consumers.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <h2>The rights of Users</h2>
                <p>
                  Users may exercise certain rights regarding their Data
                  processed by the Owner.
                </p>
                <p>In particular, Users have the right to do the following:</p>

                <ul>
                  <li>
                    <b>Withdraw their consent at any time.</b> Users have the
                    right to withdraw consent where they have previously given
                    their consent to the processing of their Personal Data.
                  </li>
                  <li>
                    <b>Object to processing of their Data.</b> Users have the
                    right to object to the processing of their Data if the
                    processing is carried out on a legal basis other than
                    consent. Further details are provided in the dedicated
                    section below.
                  </li>
                  <li>
                    <b>Access their Data.</b> Users have the right to learn if
                    Data is being processed by the Owner, obtain disclosure
                    regarding certain aspects of the processing and obtain a
                    copy of the Data undergoing processing.
                  </li>
                  <li>
                    <b>Verify and seek rectification.</b> Users have the right
                    to verify the accuracy of their Data and ask for it to be
                    updated or corrected.
                  </li>
                  <li>
                    <b>Restrict the processing of their Data.</b> Users have the
                    right, under certain circumstances, to restrict the
                    processing of their Data. In this case, the Owner will not
                    process their Data for any purpose other than storing it.
                  </li>
                  <li>
                    <b>
                      Have their Personal Data deleted or otherwise removed.
                    </b>{" "}
                    Users have the right, under certain circumstances, to obtain
                    the erasure of their Data from the Owner.
                  </li>
                  <li>
                    <b>
                      Receive their Data and have it transferred to another
                      controller.
                    </b>{" "}
                    Users have the right to receive their Data in a structured,
                    commonly used and machine readable format and, if
                    technically feasible, to have it transmitted to another
                    controller without any hindrance. This provision is
                    applicable provided that the Data is processed by automated
                    means and that the processing is based on the User's
                    consent, on a contract which the User is part of or on
                    pre-contractual obligations thereof.
                  </li>
                  <li>
                    <b>Lodge a complaint.</b> Users have the right to bring a
                    claim before their competent data protection authority.
                  </li>
                </ul>

                <h3>Details about the right to object to processing</h3>
                <p>
                  Where Personal Data is processed for a public interest, in the
                  exercise of an official authority vested in the Owner or for
                  the purposes of the legitimate interests pursued by the Owner,
                  Users may object to such processing by providing a ground
                  related to their particular situation to justify the
                  objection.
                </p>
                <p>
                  Users must know that, however, should their Personal Data be
                  processed for direct marketing purposes, they can object to
                  that processing at any time without providing any
                  justification. To learn, whether the Owner is processing
                  Personal Data for direct marketing purposes, Users may refer
                  to the relevant sections of this document.{" "}
                </p>

                <h3>How to exercise these rights</h3>
                <p>
                  Any requests to exercise User rights can be directed to the
                  Owner through the contact details provided in this document.
                  These requests can be exercised free of charge and will be
                  addressed by the Owner as early as possible and always within
                  one month.
                </p>
              </div>

              <div>
                <h2>Cookie Policy</h2>
                <p>
                  Hubsquares uses Cookies and other Identifiers. To learn more,
                  the User may consult the{" "}
                  <Link
                    to="/cookies-policy"
                    title="Cookie Policy"
                    className="text-dark font-italic"
                  >
                    Cookie Policy
                  </Link>
                  .
                </p>
              </div>

              <div>
                <h2>
                  Additional information about Data collection and processing
                </h2>
                <h3>Legal action</h3>
                <p>
                  The User's Personal Data may be used for legal purposes by the
                  Owner in Court or in the stages leading to possible legal
                  action arising from improper use of Hubsquares or the related
                  Services.
                  <br />
                  The User declares to be aware that the Owner may be required
                  to reveal personal data upon request of public authorities.
                </p>
                <h3>Additional information about User's Personal Data</h3>
                <p>
                  In addition to the information contained in this privacy
                  policy, Hubsquares may provide the User with additional and
                  contextual information concerning particular Services or the
                  collection and processing of Personal Data upon request.
                </p>
                <h3>System logs and maintenance</h3>
                <p>
                  For operation and maintenance purposes, Hubsquares and any
                  third-party services may collect files that record interaction
                  with Hubsquares (System logs) use other Personal Data (such as
                  the IP Address) for this purpose.
                </p>
                <h3>Information not contained in this policy</h3>
                <p>
                  More details concerning the collection or processing of
                  Personal Data may be requested from the Owner at any time.
                  Please see the contact information at the beginning of this
                  document.
                </p>

                <h3>How “Do Not Track” requests are handled</h3>
                <p>
                  Hubsquares does not support “Do Not Track” requests.
                  <br />
                  To determine whether any of the third-party services it uses
                  honor the “Do Not Track” requests, please read their privacy
                  policies.
                </p>

                <h3>Changes to this privacy policy</h3>
                <p>
                  The Owner reserves the right to make changes to this privacy
                  policy at any time by notifying its Users on this page and
                  possibly within Hubsquares and/or - as far as technically and
                  legally feasible - sending a notice to Users via any contact
                  information available to the Owner. It is strongly recommended
                  to check this page often, referring to the date of the last
                  modification listed at the bottom. <br />
                  <br />
                  Should the changes affect processing activities performed on
                  the basis of the User’s consent, the Owner shall collect new
                  consent from the User, where required.
                </p>
              </div>

              <div id="california_info">
                <h2>Information for Californian consumers</h2>
                <p>
                  This part of the document integrates with and supplements the
                  information contained in the rest of the privacy policy and is
                  provided by the business running Hubsquares and, if the case
                  may be, its parent, subsidiaries and affiliates (for the
                  purposes of this section referred to collectively as “we”,
                  “us”, “our”).
                </p>
                <p>
                  The provisions contained in this section apply to all Users
                  who are consumers residing in the state of California, United
                  States of America, according to &quot;The California Consumer
                  Privacy Act of 2018&quot; (Users are referred to below, simply
                  as “you”, “your”, “yours”), and, for such consumers, these
                  provisions supersede any other possibly divergent or
                  conflicting provisions contained in the privacy policy.
                </p>
                <p>
                  This part of the document uses the term “personal information“
                  as it is defined in The California Consumer Privacy Act
                  (CCPA).
                </p>

                <h3>
                  Categories of personal information collected, disclosed or
                  sold
                </h3>
                <p>
                  In this section we summarize the categories of personal
                  information that we've collected, disclosed or sold and the
                  purposes thereof.{" "}
                  <strong>
                    You can read about these activities in detail in the section
                    titled “Detailed information on the processing of Personal
                    Data” within this document.
                  </strong>
                </p>

                <h4>
                  Information we collect: the categories of personal information
                  we collect
                </h4>
                <p>
                  We have collected the following categories of personal
                  information about you: identifiers, commercial information,
                  biometric information, internet information, geolocation data,
                  sensorial information and employment related information.
                </p>
                <p>
                  We will not collect additional categories of personal
                  information without notifying you.
                </p>

                <h4>
                  How we collect information: what are the sources of the
                  personal information we collect?
                </h4>
                <p>
                  We collect the above mentioned categories of personal
                  information, either directly or indirectly, from you when you
                  use Hubsquares.
                </p>
                <p>
                  For example, you directly provide your personal information
                  when you submit requests via any forms on Hubsquares. You also
                  provide personal information indirectly when you navigate
                  Hubsquares, as personal information about you is automatically
                  observed and collected. Finally, we may collect your personal
                  information from third parties that work with us in connection
                  with the Service or with the functioning of Hubsquares and
                  features thereof.
                </p>

                <h4>
                  How we use the information we collect: sharing and disclosing
                  of your personal information with third parties for a business
                  purpose
                </h4>
                <p>
                  We may disclose the personal information we collect about you
                  to a third party for business purposes. In this case, we enter
                  a written agreement with such third party that requires the
                  recipient to both keep the personal information confidential
                  and not use it for any purpose(s) other than those necessary
                  for the performance of the agreement.
                </p>
                <p>
                  We may also disclose your personal information to third
                  parties when you explicitly ask or authorize us to do so, in
                  order to provide you with our Service.
                </p>
                <p>
                  To find out more about the purposes of processing, please
                  refer to the relevant section of this document.
                </p>

                <h4>Sale of your personal information</h4>
                <p>
                  For our purposes, the word “sale” means any “selling, renting,
                  releasing, disclosing, disseminating, making available,
                  transferring or otherwise communicating orally, in writing, or
                  by electronic means, a consumer's personal information by the
                  business to{" "}
                  <strong>
                    another business or a third party, for monetary or other
                    valuable consideration
                  </strong>
                  ”.
                </p>
                <p>
                  This means that, for example, a sale can happen whenever an
                  application runs ads, or makes statistical analyses on the
                  traffic or views, or simply because it uses tools such as
                  social network plugins and the like.
                </p>

                <h4>
                  Your right to opt out of the sale of personal information
                </h4>
                <p>
                  You have the right to opt out of the sale of your personal
                  information. This means that whenever you request us to stop
                  selling your data, we will abide by your request.
                  <br />
                  Such requests can be made freely, at any time, without
                  submitting any verifiable request, simply by following the
                  instructions below.
                </p>

                <h4>
                  Instructions to opt out of the sale of personal information
                </h4>
                <p>
                  If you’d like to know more, or exercise your right to opt out
                  in regard to all the sales carried out by Hubsquares, both
                  online and offline, you can contact us for further information
                  using the contact details provided in this document.
                </p>

                <h4>
                  What are the purposes for which we use your personal
                  information?
                </h4>
                <p>
                  We may use your personal information to allow the operational
                  functioning of Hubsquares and features thereof (“business
                  purposes”). In such cases, your personal information will be
                  processed in a fashion necessary and proportionate to the
                  business purpose for which it was collected, and strictly
                  within the limits of compatible operational purposes.
                </p>
                <p>
                  We may also use your personal information for other reasons
                  such as for commercial purposes (as indicated within the
                  section “Detailed information on the processing of Personal
                  Data” within this document), as well as for complying with the
                  law and defending our rights before the competent authorities
                  where our rights and interests are threatened or we suffer an
                  actual damage.
                </p>
                <p>
                  We will not use your personal information for different,
                  unrelated, or incompatible purposes without notifying you.
                </p>

                <h3>Your California privacy rights and how to exercise them</h3>

                <h4>The right to know and to portability</h4>
                <p>You have the right to request that we disclose to you:</p>
                <ul>
                  <li>
                    the categories and sources of the personal information that
                    we collect about you, the purposes for which we use your
                    information and with whom such information is shared;
                  </li>
                  <li>
                    in case of sale of personal information or disclosure for a
                    business purpose, two separate lists where we disclose:
                    <ul>
                      <li>
                        for sales, the personal information categories purchased
                        by each category of recipient; and
                      </li>
                      <li>
                        for disclosures for a business purpose, the personal
                        information categories obtained by each category of
                        recipient.
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  The disclosure described above will be limited to the personal
                  information collected or used over the past 12 months.
                </p>
                <p>
                  If we deliver our response electronically, the information
                  enclosed will be "portable", i.e. delivered in an easily
                  usable format to enable you to transmit the information to
                  another entity without hindrance – provided that this is
                  technically feasible.
                </p>

                <h4>
                  The right to request the deletion of your personal information
                </h4>
                <p>
                  You have the right to request that we delete any of your
                  personal information, subject to exceptions set forth by the
                  law (such as, including but not limited to, where the
                  information is used to identify and repair errors on
                  Hubsquares, to detect security incidents and protect against
                  fraudulent or illegal activities, to exercise certain rights
                  etc.).
                </p>
                <p>
                  If no legal exception applies, as a result of exercising your
                  right, we will delete your personal information and direct any
                  of our service providers to do so.
                </p>

                <h4>How to exercise your rights</h4>
                <p>
                  To exercise the rights described above, you need to submit
                  your verifiable request to us by contacting us via the details
                  provided in this document.
                </p>
                <p>
                  For us to respond to your request, it’s necessary that we know
                  who you are. Therefore, you can only exercise the above rights
                  by making a verifiable request which must:
                </p>
                <ul>
                  <li>
                    provide sufficient information that allows us to reasonably
                    verify you are the person about whom we collected personal
                    information or an authorized representative;
                  </li>
                  <li>
                    describe your request with sufficient detail that allows us
                    to properly understand, evaluate, and respond to it.
                  </li>
                </ul>
                <p>
                  We will not respond to any request if we are unable to verify
                  your identity and therefore confirm the personal information
                  in our possession actually relates to you.
                </p>
                <p>
                  If you cannot personally submit a verifiable request, you can
                  authorize a person registered with the California Secretary of
                  State to act on your behalf.
                </p>
                <p>
                  If you are an adult, you can make a verifiable request on
                  behalf of a minor under your parental authority.
                </p>
                <p>
                  You can submit a maximum number of 2 requests over a period of
                  12 months.
                </p>

                <h4>How and when we are expected to handle your request</h4>
                <p>
                  We will confirm receipt of your verifiable request within 10
                  days and provide information about how we will process your
                  request.
                </p>
                <p>
                  We will respond to your request within 45 days of its receipt.
                  Should we need more time, we will explain to you the reasons
                  why, and how much more time we need. In this regard, please
                  note that we may take up to 90 days to fulfill your request.
                </p>
                <p>
                  Our disclosure(s) will cover the preceding 12 month period.
                </p>
                <p>
                  Should we deny your request, we will explain you the reasons
                  behind our denial.
                </p>
                <p>
                  We do not charge a fee to process or respond to your
                  verifiable request unless such request is manifestly unfounded
                  or excessive. In such cases, we may charge a reasonable fee,
                  or refuse to act on the request. In either case, we will
                  communicate our choices and explain the reasons behind it.
                </p>
              </div>

              <div>
                <div>
                  <h3>Definitions and legal references</h3>
                  <div>
                    <h4>Personal Data (or Data)</h4>
                    <p>
                      Any information that directly, indirectly, or in
                      connection with other information — including a personal
                      identification number — allows for the identification or
                      identifiability of a natural person.
                    </p>

                    <h4>Usage Data</h4>
                    <p>
                      Information collected automatically through Hubsquares (or
                      third-party services employed in Hubsquares), which can
                      include: the IP addresses or domain names of the computers
                      utilized by the Users who use Hubsquares, the URI
                      addresses (Uniform Resource Identifier), the time of the
                      request, the method utilized to submit the request to the
                      server, the size of the file received in response, the
                      numerical code indicating the status of the server's
                      answer (successful outcome, error, etc.), the country of
                      origin, the features of the browser and the operating
                      system utilized by the User, the various time details per
                      visit (e.g., the time spent on each page within the
                      Application) and the details about the path followed
                      within the Application with special reference to the
                      sequence of pages visited, and other parameters about the
                      device operating system and/or the User's IT environment.
                    </p>

                    <h4>User</h4>
                    <p>
                      The individual using Hubsquares who, unless otherwise
                      specified, coincides with the Data Subject.
                    </p>

                    <h4>Data Subject</h4>
                    <p>The natural person to whom the Personal Data refers.</p>

                    <h4>Data Processor (or Data Supervisor)</h4>
                    <p>
                      The natural or legal person, public authority, agency or
                      other body which processes Personal Data on behalf of the
                      Controller, as described in this privacy policy.
                    </p>

                    <h4>Data Controller (or Owner)</h4>
                    <p>
                      The natural or legal person, public authority, agency or
                      other body which, alone or jointly with others, determines
                      the purposes and means of the processing of Personal Data,
                      including the security measures concerning the operation
                      and use of Hubsquares. The Data Controller, unless
                      otherwise specified, is the Owner of Hubsquares.
                    </p>

                    <h4>Hubsquares (or this Application)</h4>
                    <p>
                      The means by which the Personal Data of the User is
                      collected and processed.
                    </p>

                    <h4>Service</h4>
                    <p>
                      The service provided by Hubsquares as described in the
                      relative terms (if available) and on this
                      site/application.
                    </p>

                    <h4>European Union (or EU)</h4>
                    <p>
                      Unless otherwise specified, all references made within
                      this document to the European Union include all current
                      member states to the European Union and the European
                      Economic Area.
                    </p>

                    <h4>Cookies</h4>
                    <p>Small sets of data stored in the User's device.</p>

                    <hr />
                    <h4>Legal information</h4>
                    <p>
                      This privacy statement has been prepared based on
                      provisions of multiple legislations, including Art. 13/14
                      of Regulation (EU) 2016/679 (General Data Protection
                      Regulation).
                    </p>
                    <p>
                      This privacy policy relates solely to Hubsquares, if not
                      stated otherwise within this document.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <p>Latest update: June 20, 2020</p>
              </div>
            </div>
          </div>
        </div>
        <div className="position-relative py-3">
          <button
            className="text-white addbtn btn-danger btn  position-absolute bg-red"
            style={{
              right: 0,
            }}
            onClick={() => window.scrollTo(0, 0)}
          >
            {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
            Back to top
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
